export const linkedRep = (user, reps) => {
  const rep = user?.rep_id ? reps.find((r) => r.id === user.rep_id) : null;
  return rep?.active ? rep : null;
};

export const quickAddDefaults = (rep) => {
  if (!rep) return { setter: "", closer: "" };
  if (rep.role === "Closer") return { setter: "", closer: rep.id };
  return { setter: rep.id, closer: "" };
};

export const activityDefaultSetter = (rep) => (rep && ["Setter", "Both"].includes(rep.role) ? rep.id : "");
